module.exports = __webpack_public_path__ + "908e4d2e/img/delete-icon.eb7de062.svg";